import { useQuery } from '@tanstack/react-query';
import { getUserDefaultCourse } from '../../../../Utilities/api';
export const useUserDefaultCourse = () => {
    return useQuery({
        queryKey: ['default-course'],
        queryFn: () => getUserDefaultCourse(),
    });
};
